export default {"src":"/_next/static/image/public/images/packageDetailsDefault.415067caf212fda277f1c4415ae96ecb.svg","height":307,"width":548};